import { Navigate } from "react-router-dom";

import AuthRoutes from "Routes/Components/Auth";

import UseAuth from "Hooks/UseAuth";

import * as S from "./styles";

const NoAuthLayout = ({
  children,
  noHeader,
  noPadding,
  // Rota pública aberta por TOKEN (book de captação, validação do proponente,
  // apresentação da seletiva): estar logado não pode impedir o acesso. Ver o
  // comentário de `allowAuthenticated` em Routes/Components/NoAuth.js.
  allowAuthenticated = false,
}) => {
  const { authorized } = UseAuth();

  // Nas telas de login/senha, quem já entrou não tem o que fazer aqui.
  if (authorized && !allowAuthenticated)
    return <Navigate to={AuthRoutes.Dashboard.path} replace />;

  return (
    <S.MainGrid noHeader={noHeader}>
      <S.Container noPadding={noPadding}>{children}</S.Container>
    </S.MainGrid>
  );
};

export default NoAuthLayout;
